module.exports = __webpack_public_path__ + "img/ic_head.4fd15669.png";